import { query, where, or } from 'firebase/firestore';
import { ROLES } from './userService';

/**
 * Aplica filtros de visibilidade baseado no papel do usuário.
 *
 * Estrutura esperada nos documentos (clientes, simulações, PDFs):
 *   - userId: quem criou o registro
 *   - masterId: uid do master da organização
 *   - gestorId: uid do gestor responsável (se aplicável)
 *
 * Regras:
 *   - Master: vê tudo da organização (masterId == profile.uid)
 *   - Gestor: vê os próprios + os dos usuários vinculados a ele
 *   - Usuário: vê apenas os próprios (userId == profile.uid)
 */
export function applyRoleFilter(baseQuery, profile) {
  if (!profile) return baseQuery;

  switch (profile.role) {
    case ROLES.MASTER:
      // Master vê todos os dados da sua organização
      return query(baseQuery, where('masterId', '==', profile.uid));

    case ROLES.GESTOR:
      // Gestor vê os próprios dados + os dos seus usuários
      // Firestore não suporta OR nativo em queries compostas facilmente,
      // então usamos gestorId que é setado tanto nos dados do gestor quanto dos seus usuários
      return query(baseQuery, where('gestorId', '==', profile.uid));

    case ROLES.USUARIO:
    default:
      // Usuário vê apenas os próprios dados
      return query(baseQuery, where('userId', '==', profile.uid));
  }
}

/**
 * Retorna os campos extras que devem ser salvos junto com cada registro
 * para permitir filtragem por role depois.
 */
export function getOwnershipFields(profile) {
  if (!profile) return {};

  return {
    userId: profile.uid,
    masterId: profile.role === ROLES.MASTER ? profile.uid : (profile.masterId || profile.uid),
    gestorId: getGestorId(profile),
  };
}

function getGestorId(profile) {
  // Se é gestor, ele mesmo é o gestorId
  if (profile.role === ROLES.GESTOR) return profile.uid;
  // Se é usuário vinculado a um gestor
  if (profile.role === ROLES.USUARIO && profile.gestorId) return profile.gestorId;
  // Se é master, ele é o próprio gestor dos dados dele
  if (profile.role === ROLES.MASTER) return profile.uid;
  return null;
}